import React, { FC, PropsWithChildren, useContext, useMemo } from 'react'
import { DatePicker, Select } from 'antd'
import moment from 'moment-timezone'
import { Filter, SpecificDateFilter } from '../types'
import { ConditionOperatorType } from '../enums'
import classnames from 'classnames'
import {
    EditableViewContext,
    EditableViewInputWrapper,
} from '@pushly/aqe/lib/components/hoc/editable-view/editable-view-context'

type SpecificDateFilterValueBuilderProps = {
    filter: SpecificDateFilter
    onChange: (value: SpecificDateFilter) => void
    showOperator?: boolean
}

type SpecificDateConditionOperators =
    | ConditionOperatorType.EQUALS
    | ConditionOperatorType.NOT_EQUALS
    | ConditionOperatorType.GT
    | ConditionOperatorType.GTE
    | ConditionOperatorType.LT
    | ConditionOperatorType.LTE

export const SpecificDateFilterValueBuilder: FC<SpecificDateFilterValueBuilderProps> = ({
    filter,
    onChange,
    showOperator,
}) => {
    const ctxView = useContext(EditableViewContext)
    return (
        <div className="date-filter-specific-date-group">
            {!!showOperator && (
                <Select<SpecificDateConditionOperators>
                    size="middle"
                    options={[
                        { value: ConditionOperatorType.EQUALS, label: 'is equal to' },
                        { value: ConditionOperatorType.NOT_EQUALS, label: 'is not equal to' },
                        { value: ConditionOperatorType.GT, label: 'is newer than' },
                        { value: ConditionOperatorType.GTE, label: 'is newer than or equal to' },
                        { value: ConditionOperatorType.LT, label: 'is older than' },
                        { value: ConditionOperatorType.LTE, label: 'is older than or equal to' },
                    ]}
                    onChange={(v) => {
                        const newValue = { ...filter }

                        newValue.value = {
                            ...newValue.value,
                            operator: v,
                        }
                        newValue.value.meta = filter.value.meta ?? {}

                        onChange(newValue)
                    }}
                    value={filter.value.operator}
                />
            )}
            <EditableViewInputWrapper
                value={moment(filter.value.value)
                    .tz(filter.value?.meta?.timezone ?? 'UTC')
                    .format('L')}
            >
                <DatePicker
                    className={classnames(ctxView.modeClassName)}
                    inputReadOnly={ctxView.mode === 'view'}
                    value={moment(filter.value.value).tz(filter.value?.meta?.timezone ?? 'UTC')}
                    onChange={(v) => {
                        if (!v) return

                        onChange({
                            ...filter,
                            value: {
                                ...filter.value,
                                operator: filter.value.operator,
                                value: v.format('YYYY-MM-DD'),
                            },
                        } as SpecificDateFilter)
                    }}
                    format="L"
                    size="middle"
                />
            </EditableViewInputWrapper>
        </div>
    )
}
